module.exports = __webpack_public_path__ + "static/media/logo_er_turismo.19854cc8.webp";